<template>
  <div class="row">
    <div :class="isNew ? 'col-md-6 ' : 'col-lg-6 col-md-12'">

      <div class="card">
        <div :class="(loading ? 'show-loader' : 'hide-loader')">
          <div class="el-loading-spinner">
            <svg viewBox="25 25 50 50" class="circular">
              <circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
            </svg><!---->
          </div>
        </div>
        <form>
          <div class="card-content">
            <p class="text-danger" v-if="errors.has('error')">
              {{ getError('error') }}
            </p>
            <div class="row">
              <div class="col-md-12">
                <div class="form-group" v-if="isNew">
                  <label>{{$t('settingUsers.role')}}</label>
                  <select name="role" class="form-control" 
                                v-validate="modelValidate.role"
                                v-model="model.role"
                                :disabled="!isNew"
                                @change="getDriverCode(model.role)">
                    <option value="" selected disabled>{{$t('general.select')}}</option>
                    <option v-for="(role, key) in roles"
                               :value="key"
                               :label="role"
                               :key="key">
                    </option>
                  </select>
                  <small class="text-danger" v-show="role.invalid">
                    {{ getError('role') }}
                  </small>
                </div>
                <div class="form-group">
                  <label>{{$t('settingUsers.fn')}}</label>
                  <input type="text"
                         name="firstname"
                         data-vv-as="first name"
                         :placeholder="$t('settingUsers.ln')" 
                         v-validate="modelValidate.firstname"
                         v-model="model.firstname"
                         class="form-control">
                  <small class="text-danger" v-if="errors.has('firstname')">
                    {{ getError('firstname') }}
                  </small>
                </div>
                <div class="form-group">
                  <label>{{$t('settingUsers.ln')}}</label>
                  <input type="text"
                         name="lastname"
                         data-vv-as="last name"
                         :placeholder="$t('settingUsers.fn')" 
                         v-validate="modelValidate.lastname"
                         v-model="model.lastname"
                         class="form-control">
                  <small class="text-danger" v-if="errors.has('lastname')">
                    {{ getError('lastname') }}
                  </small>
                </div>
                <div class="form-group" v-if="model.role != 'DRIVER'">
                  <label>{{$t('settingUsers.email')}}</label>
                  <input type="text"
                         name="email"
                         :placeholder="$t('settingUsers.email')" 
                         v-validate="modelValidate.email"
                         v-model="model.email"
                         class="form-control">
                  <small class="text-danger" v-if="errors.has('email')">
                    {{ getError('email') }}
                  </small>
                </div>
                <div class="form-group" v-if="model.role == 'DRIVER'">
                  <label>{{$t('settingUsers.username')}}</label>
                  <input type="text"
                         name="email"
                         :placeholder="$t('settingUsers.username')" 
                         v-validate="modelValidate.email"
                         v-model="model.email"
                         class="form-control"
                         disabled>
                  <small class="text-danger" v-if="errors.has('email')">
                    {{ getError('email') }}
                  </small>
                </div>
                <div v-if="isNew" class="form-group">
                  <label class="control-label">{{$t('settingUsers.password')}}</label>
                  <input type="password" 
                          ref="password"
                          name="password" 
                          :placeholder="$t('settingUsers.password')" 
                          v-validate="modelValidate.password"
                          v-model="model.password" 
                          class="form-control">
                   <small class="text-danger" v-if="errors.has('password')">
                    {{ getError('password') }}
                  </small>
                </div>
                <div v-if="isNew" class="form-group">
                  <label class="control-label">{{$t('settingUsers.confPass')}}</label>
                  <input type="password" 
                          name="password_confirmation" 
                          :placeholder="$t('settingUsers.confPass')" 
                          v-validate="modelValidate.password_confirmation"
                          v-model="model.password_confirmation" 
                          class="form-control">
                   <small class="text-danger" v-if="errors.has('password_confirmation')">
                    {{ getError('password_confirmation') }}
                  </small>
                </div>
                <div class="form-group" v-if="model.role != 'OWNER' && !isNew">
                  <label>{{$t('settingUsers.role')}}</label>
                  <select name="role" class="form-control" 
                                v-validate="modelValidate.role"
                                v-model="model.role"
                                :disabled="!isNew">
                    <option value="" selected disabled>{{$t('general.select')}}</option>
                    <option v-for="(role, key) in roles"
                               :value="key"
                               :label="role"
                               :key="key">
                    </option>
                  </select>
                  <small class="text-danger" v-show="role.invalid">
                    {{ getError('role') }}
                  </small>
                </div>
                <div class="form-group">
                  <label>{{$t('settingUsers.lang')}}</label>
                  <select class=" form-control" placeholder=" - Select Language - " v-model="model.language" v-validate="modelValidate.language">
                    <option v-for="(label, key) in languages"
                                :value="key"
                                :label="label"
                                :key="key">{{label}}</option>
                  </select>
                  <small>{{$t('settingUsers.langMsg')}}</small>
                  <small class="text-danger" v-if="errors.has('language')">
                    {{ getError('language') }}
                  </small>
                </div>
                <div class="form-group">
                  <label>{{$t('settingUsers.avatar')}}</label>
                  <el-upload
                    action=""
                    ref="upload"
                    :limit="2"
                    :file-list="model.imagelist"
                    list-type="picture-card"
                    accept=" .jpg, .jpeg, .png"
                    :on-change="handleImgChnage"
                    :on-exceed="handleExceed"
                    :on-remove="handleRemove"
                    :auto-upload="false">
                    <i class="el-icon-plus"></i>
                    <div class="el-upload__tip" slot="tip">{{$t('validations.pictureSize')}}</div>
                  </el-upload>
                </div>
              </div>
          <!--         <div v-if="model.role == 'user'" class="col-md-12">
                <div class="form-group">
                  <label>Permissions</label>
                    <p-checkbox name="permissions" 
                                v-for="perm in permissions" 
                                v-model="model.permissions[perm.permission_id]" 
                                :value="perm.permission_id"
                                :label="perm.label"
                                :key="perm.permission_id"
                                >{{perm.label}} {{ model.permissions[perm.permission_id] }}</p-checkbox>

                </div>
              </div> -->
            </div>
          </div>
          
          <div class="card-footer ">
            <button type="submit" @click.prevent="validate" class="btn btn-fill btn-success">{{$t('general.save')}}</button>
            <button type="text" class="btn btn-danger btn-fill" title="" @click.prevent="cancelUser"> {{$t('general.cancel')}}</button>
          </div>
        </form>

      </div>
    </div>
    <div v-if="!isNew" class="col-lg-6 col-md-12">
      <div class="card">
        <div :class="(loadingReset ? 'show-loader' : 'hide-loader')">
          <div class="el-loading-spinner">
            <svg viewBox="25 25 50 50" class="circular">
              <circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
            </svg><!---->
          </div>
        </div>
        <form class="">
         <!--  <div class="card-header">

          </div> -->
          <div class="row card-content">
            <div class="col-md-12" >
              <h6 class="card-title">
                {{$t('settingUsers.resetPass')}}
              </h6>
              <hr class="sm">
            </div>
            <div class="col-md-12 form-group">
              <label class="control-label">{{$t('settingUsers.pass')}}</label>
              <input type="password" 
                          ref="password"
                          name="password" 
                          :placeholder="$t('settingUsers.pass')" 
                          v-model="model.password" 
                          class="form-control"
                          :aria-invalid="errors.has('password_2') ? true : false">
              <small class="text-danger" v-if="errors.has('password_2')">
                {{ getError('password_2') }}
              </small>
            </div>
            <div class="col-md-12 form-group">
              <label class="control-label">{{$t('settingUsers.confPass')}}</label>
              <input type="password" 
                          :placeholder="$t('settingUsers.confPass')" 
                          v-model="model.password_confirmation" 
                          class="form-control"
                          :aria-invalid="errors.has('password_confirm_2') ? true : false">
              <small class="text-danger" v-if="errors.has('password_confirm_2')">
                {{ getError('password_confirm_2') }}
              </small>
            </div>
          </div>
          <div class="row card-footer">
            <div class="col-md-12 form-group">
              <label></label>
              <button type="submit" class="btn btn-fill btn-orange" @click.prevent="validateReset">
                {{$t('general.reset')}}
              </button>
            </div>
          </div>
        </form>
      </div> <!-- end card -->
    </div> <!--  end col-md-6  -->
  </div>
</template>
<script>
  import Vue from 'vue'
  import {mapFields} from 'vee-validate'
  import {Input, Upload, Button, DatePicker} from 'element-ui'
  import swal from 'sweetalert2'
  import 'sweetalert2/dist/sweetalert2.css'

  Vue.use(DatePicker)
  Vue.use(Upload)
  Vue.use(Button)
  Vue.use(Input)

  export default {
    components: {
      [DatePicker.name]: DatePicker,
      [Upload.name]: Upload,
      [Button.name]: Button,
      [Input.name]: Input
    },
    props: {
      userId: null,
      callback: {
        required: false
      }
    },
    watch: {
      userId (value) {
        this.id = value
      }
    },
    computed: {
      ...mapFields(['name', 'last_name', 'email', 'job', 'role'])
    },
    created: function () {
      this.$nextTick(function () {
        this.loading = true
        this.loadingReset = true
      })
      this.$validator.localize('en', {
        en: {
          attributes: {
            firstname: this.$t('settingUsers.fn'),
            lastname: this.$t('settingUsers.ln')
          }
        }
      })

      var self = this
      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      }

      this.apiRequest('/listdefaults', 'GET', data, function (response) {
        if (response.status === true) {
          self.roles = response.data[0].user_roles
        }
      })

      if ((this.$route.params.id !== undefined && this.$route.params.id) ||
        (this.id !== undefined && this.id !== null)) {
        this.isNew = false
      } else {
        this.isNew = true
      }
      if (!this.isNew) {
        var id = this.$route.params.id || this.id
        this.apiRequest('/profile/' + id, 'GET', data, function (response) {
          if (response.status === true) {
            if (response.data[0].avatar) {
              response.data[0].imagelist = [{url: response.data[0].avatar}]
            } else {
              response.data[0].imagelist = []
            }

            self.model = response.data[0]

            self.$nextTick(function () {
              self.loading = false
              self.loadingReset = false
            })
          }
        })
      } else {
        this.$nextTick(function () {
          this.loading = false
          this.loadingReset = false
        })
      }
    },
    data () {
      return {
        roles: [],
        id: this.value || this.userId,
        isNew: true,
        filelist: [],
        model: {
          'lastname': '',
          'firstname': '',
          'password': '',
          'confirm_password': '',
          'role': ''
        },
        driverCode: '',
        modelValidate: {
          firstname: {required: true, min: 3},
          lastname: {required: true, min: 3},
          email: {required: true},
          role: {required: true},
          password: {required: true},
          password_confirmation: {
            required: true
          },
          username: {required: true},
          language: {required: true}
        },
        languages: this.$session.get('defaultData')['available_languages'],
        loading: true,
        loadingReset: true
      }
    },
    methods: {
      getError (fieldName) {
        return this.errors.first(fieldName)
      },
      validate () {
        this.errors['items'] = this.removeErrorByName('password_confirmation', this.errors['items'])
        this.$validator.validateAll().then(isValid => {
          if (isValid) { this.saveUser() }
        })
      },
      validateReset () {
        if (this.model.password === undefined || this.model.password === '') {
          this.errors.add('password_2', this.$t('validations.passReq'))
        } else if (this.model.password.length < 6) {
          this.errors.add('password_2', this.$t('validations.passMin'))
        } else if (this.model.password_confirmation === undefined || this.model.password_confirmation === '') {
          this.errors.add('password_confirm_2', this.$t('validations.passReq'))
        } else if (this.model.password !== this.model.password_confirmation) {
          this.errors.add('password_confirm_2', this.$t('validations.passConf'))
        } else {
          this.resetPass()
        }
      },
      handleErrors (errors) {
        for (var prop in errors) {
          if (errors.hasOwnProperty(prop)) {
            if (errors[prop].length === 1) {
              this.errors.add(prop, errors[prop][0])
            } else {
              this.errors.add(prop, errors[prop])
            }
          } else {
            this.errors.add('error', errors[prop])
          }
        }
      },
      handleImgChnage (file, fileList) {
        // const isJPG = file.type === 'image/jpeg'
        const isOkSize = file.size / 1024 / 1024 < 5
        var self = this
        if (!isOkSize) {
          swal({
            toast: true,
            type: 'warning',
            text: self.$t('validations.pictureSizeExceed'),
            position: 'top-end',
            showConfirmButton: false,
            timer: 3000
          }).then(() => {})
          .catch(() => {})
          this.$refs.upload.clearFiles()
          this.model.imagelist = []
        } else {
          if (fileList.length > 1) {
            this.model.imagelist = fileList.slice(1)
          } else {
            this.model.imagelist = fileList
          }
        }
      },
      handleRemove (file, fileList) {
        if (fileList.length === 0) {
          this.model.imagelist = []
        }
      },
      uploadImage (upload) {
      },
      handleExceed (files, fileList) {
        swal({
          text: 'Please remove the current file in order to be able to add a new one',
          type: 'warning',
          showConfirmButton: true
        })
      },
      beforeUpload (file) {
        const isOkSize = file.size / 1024 / 1024 < 5
        var self = this
        if (!isOkSize) {
          swal({
            toast: true,
            type: 'warning',
            title: self.$t('validations.pictureSizeExceed'),
            position: 'top-end',
            showConfirmButton: false,
            timer: 3000
          }).then(() => {})
          .catch(() => {})
        }
        return isOkSize
      },
      saveUser () {
        this.$nextTick(function () { this.loading = true })
        let data = {}
        if (!this.isNew) {
          data = {
            id: this.model.id,
            firstname: this.model.firstname,
            lastname: this.model.lastname,
            email: this.model.email,
            language: this.model.language
          }
          if (this.model.role !== 'OWNER') {
            data['role'] = this.model.role
          }
        } else {
          data = this.model
        }
        var companyID = this.$session.get('selectedCompany')
        data.token = this.$session.get('token')
        data.company_id = companyID
        var self = this

        if (this.isNew) {
          delete data.avatar
          this.apiRequest('/profile', 'POST', data, function (response) {
            if (response.status === true) {
              var id = response.data[0].id
              if (data.imagelist && data.imagelist[0].status === 'ready') {
                self.getBase64(data.imagelist[0].raw).then(
                  (base64enc) => {
                    var data2 = {}
                    data2.id = id
                    data2.token = data.token
                    data2.company_id = data.company_id
                    data2.avatar = base64enc

                    self.apiRequest('/profile/' + id, 'PUT', data2, function (response2) {
                      if (response2.status === true) {
                        self.errors.clear()
                        self.$nextTick(function () { self.loading = false })
                        swal(
                          {
                            title: '',
                            text: self.$t('settingUsers.userAdded'),
                            type: 'success',
                            showConfirmButton: false,
                            timer: 1500
                          }
                        )
                        .then(() => {})
                        .catch(() => {}) // end swal
                        if (typeof self.callback === 'function') {
                          self.callback()
                        } else {
                          self.$router.push('/user/edit/' + id)
                        }
                      } else {
                        self.$nextTick(function () { self.loading = false })
                        swal(
                          {
                            title: '',
                            text: self.$t('settingUsers.userPicError'),
                            type: 'danger',
                            showConfirmButton: false,
                            timer: 1500
                          }
                        )
                        .then(() => {})
                        .catch(() => {}) // end swal
                      }
                    }) // end api response2
                  }
                ) // end getBase64.then
              } else {
                self.$nextTick(function () { self.loading = false })
                self.errors.clear()
                swal(
                  {
                    title: '',
                    text: self.$t('settingUsers.userAdded'),
                    type: 'success',
                    showConfirmButton: false,
                    timer: 1500
                  }
                )
                .then(() => {})
                .catch(() => {})
                if (typeof self.callback === 'function') {
                  self.callback()
                } else {
                  self.$router.push('/user/edit/' + id)
                }
              }
            } else {
              self.$nextTick(function () { self.loading = false })
              self.handleErrors(response.errors)
            }
          })
        } else {
          var id = this.id || this.$route.params.id

          if (data.role === 'OWNER') {
            delete data.role
          }

          delete data.avatar
          // check if the've removed the picture
          if (this.model.imagelist.length === 0) {
            data.avatar = ''
          }

          var user = JSON.parse(this.$session.get('userData'))
          if (id === user.id) {
            var url = '/profile/me'
          } else {
            url = '/profile/' + id
          }

          this.apiRequest(url, 'PUT', data, function (response) {
            if (response.status === true) {
              if (id === user.id) {
                console.warn(data.language)
                self.$i18n.locale = data.language
                self.$session.set('userData', JSON.stringify(response.data[0]))
              }
              if (self.model.imagelist.length && self.model.imagelist[0].status && self.model.imagelist[0].status === 'ready') {
                self.getBase64(self.model.imagelist[0].raw).then(
                  (base64enc) => {
                    var data2 = {}
                    data2.id = id
                    data2.token = data.token
                    data2.company_id = data.company_id
                    data2.avatar = base64enc

                    self.apiRequest('/profile/' + id, 'PUT', data2, function (response2) {
                      if (response2.status === true) {
                        var user = JSON.parse(self.$session.get('userData'))
                        if (id === user.id) {
                          self.$session.set('companyAvatar', data2.avatar)
                        }
                        self.$nextTick(function () { self.loading = false })
                        swal(
                          {
                            title: '',
                            text: self.$t('settingUsers.userUpdated'),
                            type: 'success',
                            showConfirmButton: false,
                            timer: 1500
                          }
                        )
                        .then(() => {})
                        .catch(() => {}) // end swal
                        if (typeof self.callback === 'function') {
                          self.callback()
                        }
                      } else {
                        self.$nextTick(function () { self.loading = false })
                        swal(
                          {
                            title: '',
                            text: self.$t('settingUsers.userPicError'),
                            type: 'danger',
                            showConfirmButton: false,
                            timer: 1500
                          }
                        )
                        .then(() => {})
                        .catch(() => {}) // end swal
                      }
                    }) // end api response2
                  }
                ) // end getBase64.then
              } else {
                self.$nextTick(function () { self.loading = false })
                swal(
                  {
                    title: '',
                    text: self.$t('settingUsers.userUpdated'),
                    type: 'success',
                    showConfirmButton: false,
                    timer: 1500
                  }
                )
                .then(() => {})
                .catch(() => {})
                if (typeof self.callback === 'function') {
                  self.callback()
                }
              }
            } else {
              self.$nextTick(function () { self.loading = false })
              self.handleErrors(response.errors)
            }
          }) // end api response
        }
      },
      resetPass () {
        this.$nextTick(function () { this.loadingReset = true })
        var id = this.id || this.$route.params.id
        var data = {
          company_id: this.$session.get('selectedCompany'),
          token: this.$session.get('token'),
          password: this.model.password,
          password_confirmation: this.model.password_confirmation
        }
        // var self = this
        var self = this
        this.apiRequest('/profile/' + id, 'PUT', data, function (response) {
          if (response.status === true) {
            self.$nextTick(function () { self.loadingReset = false })
            swal({'text': 'New password saved succesfully', 'type': 'success', 'showConfirmButton': false, 'timer': 2000})
            .then(() => {})
            .catch(() => {})
          } else {
            self.$nextTick(function () { self.loadingReset = false })
            swal({'text': self.$t('validations.wentWrong'), 'type': 'error', 'showConfirmButton': false, 'timer': 2000})
            .then(() => {})
            .catch(() => {})
          }
        })
      },
      getDriverCode (role) {
        if (role === 'DRIVER') {
          if (this.driverCode === '' || this.driverCode === null) {
            var id = this.$session.get('selectedCompany')
            var data = {
              company_id: id,
              token: this.$session.get('token')
            }
            var self = this

            this.apiRequest('/settings/newdriver/' + id, 'GET', data, function (response) {
              if (response.status === true) {
                self.driverCode = response.data['email']
                self.model.email = self.driverCode
              } else {
                swal({'text': response.error['email'] ? response.error['email'] : self.$t('validations.wentWrong'), 'type': 'error'}).catch({})
              }
            })
          } else {
            this.model.email = this.driverCode
          }
        } else {
          this.model.email = ''
        }
      },
      cancelUser () {
        if (typeof this.callback === 'function') {
          this.callback()
        }
      }
    }
  }
</script>
<style>
  .upload-demo input[type="file"]{ display: none; }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Settings/Users/UserForm.vue